var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-model-material-configurator-model-updater]').each(function() {
    var $el = $(this);
    var modelId = $(this).attr('data-sw-model-material-configurator-model-updater');
    var url = $el.find('[data-sw-model-material-configurator-model-updater-form]').attr('action');
    // Find the default selected scale so this does not have to be hardcoded
    var defaultScale = $el.find('[data-sw-model-material-configurator-model-updater-default-scale]').attr('value');

    var $fileInput = $el.find('[data-sw-model-material-configurator-model-updater-file-input]');
    var acceptedFileExtensionsAttr = $fileInput.attr('accept');
    var maxFileSize = $fileInput.attr('data-sw-max-file-size');

    var el = this;
    require([
      'vue',
      'rrViewComponents/Model/Tools/ModelToolsComponent/sw-model-tools.vue'
    ], function (Vue, ModelToolsComponent) {

      new Vue({
        el: el,
        data: {
          modelId: modelId,
          hasUpdatedFile: false,
          file: null,
          scale: defaultScale, // Default scale value - MM
          errorMessage: null,
          uploadingModel: false // Uploading model loading state
        },
        components: {
          'sw-model-tools': ModelToolsComponent.default
        },
        methods: {
          clickUpdateFileLabel: function () {
            this.$refs.fileInputLabel.click();
          },
          fileInputUpdated: function ($event) {
            var files = $event.target.files;
            if (files.length > 1) {
              this.errorMessage = 'moreThanOneFileError';
              return;
            }
            var file = $event.target.files[0];
            if (!file) {
              return;
            }

            if (acceptedFileExtensionsAttr) {
              var acceptedFileExtensions = acceptedFileExtensionsAttr.split(',');
              var re = /\.[^.]+?$/;
              // Get the file extension
              var extension = re.exec(file.name)[0];
              if (!extension || acceptedFileExtensions.indexOf(extension.toLowerCase()) === -1) {
                this.errorMessage = 'fileFormatError';
                return;
              }
            }

            if (maxFileSize && file.size > parseInt(maxFileSize)) {
              this.errorMessage = 'fileSizeError';
              return;
            }

            this.file = file;
            this.hasUpdatedFile = true;
            this.errorMessage = null;
          },
          updateFile: function () {
            var _this = this;

            var formData = new window.FormData();
            // take the model data and append it to the form data
            for (var key in this._data) {
              if (!this._data.hasOwnProperty(key) || this._data[key] === null) {
                continue;
              }
              formData.append(key, this._data[key]);
            }

            var ajaxParams = {
              url: url,
              type: 'post',
              data: formData,
              processData: false,
              contentType: false,
              dataType: 'json',
              success: function(data) {
                if (data.success) {
                  // Refresh the page to get back into the processing state
                  window.location.reload();
                } else {
                  _this.errorMessage = data.error || 'genericError';
                  _this.hasUpdatedFile = false;
                  _this.uploadingModel = false;
                }
              },
              error: function() {
                _this.errorMessage = 'genericError';
                _this.hasUpdatedFile = false;
                _this.uploadingModel = false;
              },
            };
            $.ajax(ajaxParams);

            _this.uploadingModel = true;
          }
        }
      });
    });
  });
};
